export class Observable {
  constructor(initialValue) {
    this._value = initialValue;
    this._oldValue = null;
    this._callbacks = [];
  }

  get value() {
    return this._value;
  }

  set value(newValue) {
    if (this._value !== newValue) {
      this._oldValue = this._value;
      this._value = newValue;
      this._callbacks.forEach(callback => callback(this._value, this._oldValue));
    }
  }

  subscribe(callback) {
    this._callbacks.push(callback);
    return () => this.unsubscribe(callback);
  }

  unsubscribe(callback) {
    const index = this._callbacks.indexOf(callback);
    if (index !== -1) {
      this._callbacks.splice(index, 1);
    }
  }
}
